// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__psLwB","reportBodyText":"style__reportBodyText__DN98k"};